<template>
    <div class="ct-aside-control ct-aside-control-light ct-aside-data"
        :class="[modalPositionClass, modalSizeClass, {'ct-aside-control-slide-open': show}]">
		<div class="ct-aside-control-actions">
            <slot name="modal-header-actions"></slot>
            <button v-if="closeBtn"
                type="button"
                title="Fechar"
                @click="$emit('close')"
                class="close position-absolute pos-top pos-right"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">
                    <!-- <i class="fas fa-times"></i> -->
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-13"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>
                </span>
            </button>
        </div>
        <transition name="transition-fade">
            <div class="ct-aside-control-content" v-if="showContent">
                <div :class="[{'d-flex flex-column flex-fill': fullHeight}, classContent]">
                    <slot name="content"></slot>
                </div>
            </div>
        </transition>
	</div>
</template>

<script>
    export default {
    	name: 'modalData',
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            showContent: {
                type: Boolean,
                default: false,
            },
            fullHeight: {
                type: Boolean,
                default: true,
            },
            position: {
                type: String,
                default: 'right',
            },
            size: {
                type: String,
                default: '',
            },
            closeBtn: {
                type: Boolean,
                default: true
            },
            classContent: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
            }
        },
        computed: {
            modalPositionClass() {
                if(this.position){
                    return 'ct-aside-'+this.position;
                }
                return 'ct-aside-right';
            },
            modalSizeClass() {
                if(this.size){
                    return 'ct-aside-'+this.size;
                }
                return '';
            },
        },
    }
</script>


<style scoped lang="scss">
@import "@styles/_mixins.scss";
@import "@styles/_theme.scss";
//@import "@styles/_theme.scss";

.transition-fade-enter-active, .transition-fade-leave-active {
  transition: opacity 1s;
}
.transition-fade-enter, .transition-fade-leave-to{
  opacity: 0;
}

.ct-aside-control {
    &.ct-aside-data {
        &.ct-aside-control-slide-open{
            &.ct-aside-right {
                // width: $navbar-sidebar-occurrence-width;
                // right: - ($navbar-sidebar-occurrence-width + 10);

                left: auto;

                &:not(.ct-aside-small):not(.ct-aside-medium){
                    right: -105%;
                    width: 100%;

                    // min-width: 400px;
                    // max-width: 45%;

                    @include md {
                        right: -50%;
                        width: 49%;
                        min-width: 400px;
                        max-width: 53%;
                    }
                    @include lg {
                        right: -46%;
                        width: 45%;
                        max-width: 50%;
                    }
                    @include xxl {
                        right: -36%;
                        width: 35%;
                        max-width: 40%;
                    }

                    .ct-aside-control-content {
                        padding: 1.8rem 0 0 1rem;
                        @include sm {
                            padding: 2rem 0 0 2rem;
                        }
                        @include md {
                            padding: 2.2rem 0 0 2.2rem;
                        }
                        @include lg {
                            padding: 2.5rem 0 0 2.5rem;
                        }
                        @include xxl {
                            padding: 3rem 0 0 3rem;
                        }

                        > div {
                        padding-right: 1rem;

                            @include sm {
                                padding-right: 2rem;
                            }
                            @include md {
                                padding-right: 2.2rem;
                            }
                            @include lg {
                                padding-right: 2.5rem;
                            }
                            @include xxl {
                                padding-right: 3rem;
                            }
                        }
                    }
                }
            }

            &.ct-aside-full {
                .ct-aside-control-content {
                    padding: 1rem;
                    @include sm {
                        padding: 1.5rem;
                    }

                }
            }
        }
    }

}

</style>
